import { IUpdateDiarioObraParalisacoesUseCase } from "../../../presentation/useCases/update/update_diario_obras_paralisacoes_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// UpdateDiarioObraParalisacoesUseCase


export class UpdateDiarioObraParalisacoesUseCase implements IUpdateDiarioObraParalisacoesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async updateDiarioObraParalisacoes( IdDiarioObrasParalisacoes: number, IdDiarioObras: number | null, HorarioInicio: string | null, HorarioFim: string | null, Motivo: string | null, Assunto: string | null, TempoParalisacao: string | null): Promise<void> {
    
    await this.repository.updateDiarioObraParalisacoes(
        IdDiarioObrasParalisacoes, IdDiarioObras, HorarioInicio, HorarioFim, Motivo, Assunto, TempoParalisacao
    );
  }
}
